<div class="plan-options-container" [ngClass]="{ 'in-wizard': isInWizard }">
    <div *ngIf="!isInWizard" class="header-container">
        <button
            *ngIf="activeView === servicePlanDialogViewOptions.COMPARE_PLANS"
            class="mat-button icon-button back"
            aria-label="back to select plan"
            (click)="goBack()"
        >
            <mat-icon>chevron_left</mat-icon>
        </button>
        <h2>{{ activeView === servicePlanDialogViewOptions.SELECT_PLAN ? "Plan Options" : "Compare Plans" }}</h2>
        <button class="mat-button icon-button close" aria-label="close dialog" [mat-dialog-close]="">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div #dialogContent mat-dialog-content class="content-container">
        <clare-spinner *ngIf="isSaving" text="Saving plan updates"></clare-spinner>
        <div class="scrollable-region">
            <ng-container *ngIf="activeView === servicePlanDialogViewOptions.SELECT_PLAN; else comparePlans">
                <a
                    *ngIf="!(isMobile || isCompareBtnHidden)"
                    class="link-button compare-plans"
                    (click)="activeView = servicePlanDialogViewOptions.COMPARE_PLANS"
                    >Compare Plans</a
                >
                <mat-radio-group aria-label="Select an option">
                    <button
                        *ngFor="let plan of plans$ | async"
                        class="plan-wrapper"
                        [ngClass]="{ selected: isSelectedPlan(plan.id) }"
                        [style.background]="getColor(plan)"
                        [disabled]="isSelectionDisabled"
                        (click)="selectPlan(plan)"
                    >
                        <div>
                            <mat-radio-button
                                class="checkbox"
                                [checked]="isSelectedPlan(plan.id)"
                                [value]="plan.id"
                                [disabled]="isSelectionDisabled"
                            ></mat-radio-button>
                        </div>
                        <div>
                            <p class="name">{{ plan.name }}</p>
                            <p class="description">{{ plan.description }}</p>
                        </div>
                    </button>
                </mat-radio-group>

                <ng-container *ngIf="allFeatures$">
                    <div class="additional-features-header">Additional Features</div>
                    <div class="feature-wrapper">
                        <div class="feature-container" *ngFor="let feature of allFeatures$ | async">
                            <div class="feature-name-container">
                                <p class="feature-name">{{ feature?.featureName }}</p>
                                <mat-slide-toggle
                                    color="primary"
                                    [aria-label]="true"
                                    [checked]="isEnabled(feature)"
                                    [disabled]="isSelectionDisabled"
                                    (change)="updateFeatureStatus(feature, $event)"
                                ></mat-slide-toggle>
                            </div>
                            <p class="feature-description" [innerHTML]="getFeatureDescription(feature.description)"></p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #comparePlans>
                <app-service-plan-table
                    [availablePlans]="availablePlans"
                    [availablePlanFeatures]="availablePlanFeatures"
                    [project]="project"
                    [isDialog]="true"
                    [currentPlan]="selectedPlan"
                    (selectedPlan)="selectPlan($event, true)"
                ></app-service-plan-table>
            </ng-template>
        </div>
    </div>

    <div *ngIf="activeView === servicePlanDialogViewOptions.SELECT_PLAN && !isInWizard" class="footer-container">
        <div class="btn-container">
            <button mat-stroked-button class="footer-btn cancel-btn" [mat-dialog-close]="">Cancel</button>
            <button
                mat-raised-button
                class="footer-btn new-primary-button"
                [disabled]="!isSaveEnabled || isSaving || isSelectionDisabled"
                (click)="onSave()"
            >
                Save
            </button>
        </div>
    </div>
</div>
